/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UserInfoResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Userinfo<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UserinfoList
   * @request GET:/userinfo
   */
  userinfoList = (params: RequestParams = {}) =>
    this.request<UserInfoResponse, any>({
      path: `/userinfo`,
      method: "GET",
      format: "json",
      ...params,
    });
}
